import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconMail,
  IconMapPin,
  IconPhone,
} from "@tabler/icons-react";
import classes from "./TopContactBar.module.css";

// Per-tenant contact strip shown above the main nav. No shared backend/CMS source for this
// yet, so it's a local map keyed by REACT_APP_TENANT_NAME — tenants without an entry here
// just don't get the bar (no invented addresses/phone numbers).
const TENANT_CONTACT_INFO = {
  celotleti: {
    addresses: ["Citadeles 1A, Rīga", "Ģimnāzijas 34/36, Daugavpils"],
    phone: "29701117",
    email: "info@avioagents.lv",
    facebookUrl: "https://www.facebook.com/celotleti.lv",
    instagramUrl: "https://www.instagram.com/celotleti.lv",
  },
};

function SocialIcon({ href, children }) {
  if (!href) return <span className={classes.social}>{children}</span>;
  return (
    <a href={href} target="_blank" rel="noreferrer" className={classes.social}>
      {children}
    </a>
  );
}

export function TopContactBar() {
  const tenant = window.SERVER_DATA?.REACT_APP_TENANT_NAME;
  const info = TENANT_CONTACT_INFO[tenant];
  if (!info) return null;

  return (
    <div className={classes.bar}>
      <div className={classes.inner}>
        <div className={classes.left}>
          {info.addresses.map((address) => (
            <span key={address} className={classes.item}>
              <IconMapPin size={14} stroke={1.75} />
              {address}
            </span>
          ))}
        </div>
        <div className={classes.right}>
          {info.phone && (
            <a href={`tel:${info.phone}`} className={classes.item}>
              <IconPhone size={14} stroke={1.75} />
              {info.phone}
            </a>
          )}
          {info.email && (
            <a href={`mailto:${info.email}`} className={classes.item}>
              <IconMail size={14} stroke={1.75} />
              {info.email}
            </a>
          )}
          <span className={`${classes.socialGroup} ${classes.desktopOnly}`}>
            <SocialIcon href={info.facebookUrl}>
              <IconBrandFacebook size={16} stroke={1.75} />
            </SocialIcon>
            <SocialIcon href={info.instagramUrl}>
              <IconBrandInstagram size={16} stroke={1.75} />
            </SocialIcon>
          </span>
        </div>
      </div>
    </div>
  );
}
